import styled from 'styled-components';
import PropTypes from 'prop-types';
import BaseBox from '@tds/core-box';

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 300px;
`;

export const Box = styled(BaseBox)`
  width: ${props => props.width};
`;

Box.propTypes = {
  width: PropTypes.string
};

Box.defaultProps = {
  width: '100%'
};
